var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.71835 9.7101C1.6489 9.89719 1.6489 10.103 1.71835 10.2901C2.39476 11.9302 3.54294 13.3326 5.01732 14.3193C6.4917 15.3061 8.22588 15.8329 10 15.8329C11.7741 15.8329 13.5083 15.3061 14.9827 14.3193C16.4571 13.3326 17.6053 11.9302 18.2817 10.2901C18.3511 10.103 18.3511 9.89719 18.2817 9.7101C17.6053 8.06998 16.4571 6.66763 14.9827 5.68085C13.5083 4.69406 11.7741 4.16728 10 4.16728C8.22588 4.16728 6.4917 4.69406 5.01732 5.68085C3.54294 6.66763 2.39476 8.06998 1.71835 9.7101Z",
    stroke: "#506360",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "#506360",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.b0bc8626147ca8bd2e4f77cbd1c645fc.svg";
export { ForwardRef as ReactComponent };